import { render } from "./CreateClientOffer.vue?vue&type=template&id=20c09a3a"
import script from "./CreateClientOffer.vue?vue&type=script&lang=js"
export * from "./CreateClientOffer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__